import _ from 'lodash'
import FileSaver from 'file-saver'
import api from '@/api/api'
import moment from 'moment-timezone'

import ScrollTo from '@/components/general/scroll-to/scroll-to'
import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import SelectField from '@/components/general/fields/select/select'
import CheckboxField from '@/components/general/fields/checkbox/checkbox'
import DateField from '@/components/general/fields/date/date'

export default {
	name: 'reports-cci',
	data () {
		return {
			clients : [],
			filters : {
				since : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : '',
					value     : '',
					name      : this.$t('private.reports.master_data.filters.since'),
					error     : false,
					active    : false,
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				until : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : '',
					value     : '',
					name      : this.$t('private.reports.master_data.filters.until'),
					error     : false,
					active    : false,
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				limit : {
					id        : _.uniqueId('field_'),
					display   : true,
					fakeValue : this.$t('private.reports.master_data.filters.limit_options.10'),
					value     : 10,
					name      : this.$t('private.reports.master_data.filters.limit'),
					error     : false,
					active    : false,
					options : [{
						fakeValue : this.$t('private.reports.master_data.filters.limit_options.10'),
						value : 10
					},{
						fakeValue : this.$t('private.reports.master_data.filters.limit_options.25'),
						value : 25
					},{
						fakeValue : this.$t('private.reports.master_data.filters.limit_options.50'),
						value : 50
					},{
						fakeValue : this.$t('private.reports.master_data.filters.limit_options.100'),
						value : 100
					}],
					style     : {
						width : '230px',
						display : 'inline-block',
						margin : '0px 10px'
					}
				},
				skip : {
					value : 0
				}
			},
			getClientsActive : false,
			activateFilters : false,
			haveData : false,
			nextPage : false,
      exportDataActive : false
		}
	},
	methods : {
		getClients () {

			let vm = this

			vm.getClientsActive = true
      vm.clients = []

			let since = vm.filters.since.value ? moment(vm.filters.since.value).startOf('day').toDate() : '' ;
			let until = vm.filters.until.value ? moment(vm.filters.until.value).endOf('day').toDate() : '' ;

			let dataToSend =
				'/?descending=' + 'createdAt'                  +
				'&since='       + since                        +
				'&until='       + until                        +
				'&limit='       + (vm.filters.limit.value + 1) +
				'&skip='        + vm.filters.skip.value

			api
				.clients
				.getClients(dataToSend)
				.then( (response) => {

					vm.getClientsActive = false

					if( response.status != 200 ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					if( !response.data.success ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					vm.clients = response.data.clients

					if( vm.clients.length > 0 && !vm.haveData ){

						vm.haveData = true

					}

					if( vm.clients.length > vm.filters.limit.value ){

						vm.nextPage = true

						vm.clients.pop()

					}else{

						vm.nextPage = false

					}

				})

		},
		goToBackPage () {

			let vm = this

			if( vm.filters.skip.value != 0 ){

				vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

				vm.getClients()

			}

		},
		goToNextPage () {

			let vm = this

			if( vm.nextPage ){

				vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

				vm.getClients()

			}

		},
		exportData () {

			let vm = this

			let dataToSend = {
				headers : [
					vm.$t("private.reports.cci.table.client_code"),
					vm.$t("private.reports.cci.table.legal_name"),
					vm.$t("private.reports.cci.table.image_conditions")
				],
        timeZone: moment.tz.guess()
			}

      vm.exportDataActive = true
			api
				.reports
				.exportCCI(dataToSend)
				.then( (response) => {

					vm.getClientsActive = false
          vm.exportDataActive = false

					if( response.status != 200 ){

						let message = {
							message : [vm.$t('errors.custom.001')],
							type    : 'error'
						}

						vm.$root.$emit('showMessage', message)

						return

					}

					let file    = new Blob([response.data], { type : 'application/vnd.ms-excel' })
					let fileURL = URL.createObjectURL(file)

					FileSaver.saveAs(file, 'cci.xlsx')

					vm.getClients()

				})

		}
	},
	components : {
		MenuMoreOptions,
		TextField,
		SelectField,
		CheckboxField,
		DateField
	},
	created () {

		let vm = this

		vm.getClients()

	}
}



// WEBPACK FOOTER //
// ./src/components/private/reports/cci/script.js